import { useFont, useRadius } from '@octane/spark'
import styled, { css } from 'styled-components'

export const Wrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 5px;

    & *,
    & {
        margin: 0;
    }
`

export const ToggleList = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: stretch;
    min-height: 49px;

    ${() => useFont('c16')};
    color: ${({ theme }) => theme.colors.monochrome.ravenSub};
`

export const ToggleButton = styled.button<{ active: boolean }>`
    cursor: pointer;
    width: 100%;
    padding-left: 5px;
    padding-right: 5px;
    font: inherit;
    color: inherit;
    background-color: ${({ theme }) => theme.colors.monochrome.white};
    border-width: 1px;
    border-style: solid;
    border-color: ${({ theme }) => theme.colors.monochrome.graphite};
    border-radius: 0;
    border-right-width: 0;
    transition: all 0.15s ease-out;

    &:focus-visible {
        outline: 2px solid ${({ theme }) => theme.colors.brand.primary};
        outline-offset: -2px;
    }

    &:first-child {
        border-top-left-radius: ${() => useRadius()};
        border-bottom-left-radius: ${() => useRadius()};
    }

    &:last-child {
        border-top-right-radius: ${() => useRadius()};
        border-bottom-right-radius: ${() => useRadius()};
        border-right-width: 1px;
    }

    ${({ active, theme }) =>
        active &&
        css`
            background-color: ${theme.colors.brand.primary};
            color: ${theme.colors.monochrome.white};
            border-color: ${theme.colors.brand.primary};
            font-weight: 700;
        `}

    ${({ active, theme }) =>
        !active &&
        css`
            :hover {
                background-color: ${theme.colors.monochrome.smoke};
            }
        `}
`
